import { useParams } from "react-router-dom";
import { useApiQuery } from "../../../../../../common/infrastructure/hooks/useApiQuery";
import { endpointsMetadata } from "../../../../../../common/infrastructure/routes/endpointsMetadata";
import { IBodyMetricsDataSource } from "../../../../../../common/components/bodyMetrics/models/bodyMetricModels";
import { IUserModel } from "../../models/userModel";

/**
 * Backs the staff page on a user's profile. Resolves the user (for the name above the
 * cards) and points the shared BodyMetricsOverview at the userId-scoped endpoints - the
 * same view the user sees on "Моите метрики".
 */
export const useUserBodyMetricsPage = () => {
  const { id } = useParams();
  const userId = Number(id);

  const { data: user } = useApiQuery<IUserModel>({
    queryKey: [endpointsMetadata.user.getUser, id],
    endpoint: `${endpointsMetadata.user.getUser}?userId=${id}`,
    enabled: id !== undefined,
    globalIsLoading: false,
  });

  const userName = user ? `${user.firstName} ${user.lastName}`.trim() : undefined;

  const dataSource: IBodyMetricsDataSource = {
    listEndpoint: `${endpointsMetadata.bodyMetric.getUserBodyMetrics}?userId=${userId}`,
    listQueryKey: [endpointsMetadata.bodyMetric.getUserBodyMetrics, userId],
    addEndpoint: endpointsMetadata.bodyMetric.addUserBodyMetric,
    deleteEndpoint: endpointsMetadata.bodyMetric.deleteUserBodyMetric,
    extraPayload: { userId },
  };

  return { userName, dataSource };
};
